export default __webpack_public_path__ + "static/media/awsinfrastructuredesign.3dca18b6.png";